const re = /\(\(([^)]+)\)\)/;

export const pluralize = (count, str) => {
	// NOTE `Math.max()` numerifies all arguments
	// TODO Implement `numify()` on `count` to ensure it defaults to 0
	const c = Math.max(count, 0);

	return str.replace(re, (_, p1) => {
		const pieces = p1.split('|');
		const [zero, single, plural] =
			pieces.length === 1 ? [pieces[0], '', pieces[0]]
			: pieces.length === 2 ? [pieces[1], pieces[0], pieces[1]]
			: [pieces[2], pieces[0], pieces[1]];

		if (c === 0) {
			return zero;
		} else if (c === 1) {
			return single;
		} else {
			return plural;
		}
	});
};
